import envConfig from '@hulu/env-config';

export const defaultErrorMessage = 'Something went wrong. Please try again later.';

export const isDemoEnvironment = process.env.NODE_ENV === 'demo' || envConfig.REACT_APP_IS_DEMO_ENVIRONMENT === 'true';
